import React, { useState } from "react";
import { t } from "../../i18n";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./FAQAccordion.css";

const generateFAQs = (service, location, locale) => [
  { q: t("faq.whatIs.q", locale, { service: service.display }), a: t("faq.whatIs.a", locale, { service: service.display, city: location.city }) },
  { q: t("faq.cost.q", locale, { service: service.display, city: location.city }), a: t("faq.cost.a", locale, { city: location.city }) },
  { q: t("faq.insurance.q", locale, { service: service.display }), a: t("faq.insurance.a", locale) },
  { q: t("faq.appointment.q", locale, { city: location.city }), a: t("faq.appointment.a", locale, { city: location.city }) },
  { q: t("faq.bring.q", locale, { service: service.display }), a: t("faq.bring.a", locale) },
  { q: t("faq.workersComp.q", locale, { service: service.display }), a: t("faq.workersComp.a", locale, { service: service.display }) },
];

export default function FAQAccordion({ service, location, locale = "en" }) {
  const [openIndex, setOpenIndex] = useState(0);
  const faqs = generateFAQs(service, location, locale);

  return (
    <section className="faq-section">
      <div className="container">
        <h2>{t("section.faq", locale)}</h2>
        <div className="faq-list">
          {faqs.map((faq, i) => (
            <div key={i} className={`faq-item ${openIndex === i ? "open" : ""}`}>
              <button className="faq-question" onClick={() => setOpenIndex(openIndex === i ? -1 : i)}>
                <span>{faq.q}</span>
                {openIndex === i ? <FaChevronUp /> : <FaChevronDown />}
              </button>
              {openIndex === i && <div className="faq-answer"><p>{faq.a}</p></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
